// extracted by extract-css-chunks-webpack-plugin
module.exports = {"content":"_3t0OX","header":"KSyl-","title":"_3yYhq","bio":"_3xc91"};